import wrapper from "./wrapper.html";
import "./style.less";

class DatapointController {
	constructor($scope, eventBus, appState, $logger, loadingService, api, uiHelpers) {
		this._scope = $scope;
		this.form = appState.forms.selected;
		this.logger = $logger;
		this.appState = appState;
		this.uiHelpers = uiHelpers;
	}

	$onChanges(changes) {
		if(changes.ngModel && !changes.ngModel.currentValue) {
			this.value = undefined;
			if(this.choicesBox) {
				this.choicesBox.clearSelected();
			}
		}
	}

	$onInit() {
		this.form = this.appState.forms.selected;
	}

	setBox(box) {
		this.choicesBox = box;

		this.setChoices();
	}

	onChanged(item) {
		if(item === undefined || item === null || item === "") {
			this.ngModelCtrl.$setViewValue(null);
			return;
		}

		const options = Array.isArray(this.options) ? this.options : [];
		const subjectEntity = options.find((o) => o?.Id?.toString() === item.toString());

		if(subjectEntity === undefined) {
			this.ngModelCtrl.$setViewValue(null);
			return;
		}
		
		const modelValue = subjectEntity[this.schema.modelProperty];
		this.ngModelCtrl.$setViewValue(modelValue);
	}

	setChoices() {
		const field = this.form.Fields.find(f => f.Key.Code === this.schema.fieldCode);
		if(field === undefined) {
			this.options = [];
			
			return;
		}

		const data = field.Data;

		if(data) {
			this.options = data;
		}

		if(!this.options || !Array.isArray(this.options)) {
			this.box.clearStore();
			return;
		}

		const activeOptions = this.options.filter((option) => option.IsActive || option.IsActive === undefined);

		const listRenderingDirectives = field.RenderingDirectives?.Display?.List;
		const selectionChoices = this.uiHelpers.setDisplay(
			activeOptions, 
			{ 
				recentlyUsedEnabled: field.IsRecentlyUsedEnabled, 
				hideCode: field.IsCodeHidden 
			}, 
			listRenderingDirectives
		);

		this.choicesBox.setChoices(selectionChoices, "value", "label", true);
	}
}

export default angular
	.module("vesl.extensions.json-schema.datapoint.controller", [])
	.component("datapointAddOn", {
		controller: DatapointController,
		template: wrapper,
		require: { ngModelCtrl: "^ngModel" },
		bindings: {
			schema: "<",
			ngModel: "<"
		}
	}).name;
